import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.string.includes.js";
import { defineStore } from 'pinia';
export var SendTicketsStep = /*#__PURE__*/function (SendTicketsStep) {
  SendTicketsStep[SendTicketsStep["SelectUser"] = 0] = "SelectUser";
  SendTicketsStep[SendTicketsStep["AddTickets"] = 1] = "AddTickets";
  SendTicketsStep[SendTicketsStep["Review"] = 2] = "Review";
  SendTicketsStep[SendTicketsStep["Finish"] = 3] = "Finish";
  SendTicketsStep[SendTicketsStep["SelectNewUser"] = 4] = "SelectNewUser";
  return SendTicketsStep;
}({});
export var SelectSeatsModes = /*#__PURE__*/function (SelectSeatsModes) {
  SelectSeatsModes[SelectSeatsModes["BestAvailable"] = 0] = "BestAvailable";
  SelectSeatsModes[SelectSeatsModes["ManuallyChosen"] = 1] = "ManuallyChosen";
  return SelectSeatsModes;
}({});
var useSendTicketsStoreDefinition = defineStore('sendTickets', {
  state: function state() {
    return {
      validSteps: [],
      emails: [],
      tickets: [],
      preparedTickets: [],
      event: null,
      cancelModal: false,
      ticketFormat: null,
      note: null,
      selectSeatsMode: null,
      holdToken: null
    };
  },
  getters: {
    getHoldToken: function getHoldToken(state) {
      return state.holdToken;
    },
    getSelectSeatsMode: function getSelectSeatsMode(state) {
      return state.selectSeatsMode;
    },
    getNote: function getNote(state) {
      return state.note;
    },
    getEmails: function getEmails(state) {
      return state.emails;
    },
    getNumberOfEmails: function getNumberOfEmails(state) {
      return state.emails.length;
    },
    getSteps: function getSteps(state) {
      return state.validSteps;
    },
    getTickets: function getTickets(state) {
      return state.tickets;
    },
    getEvent: function getEvent(state) {
      return state.event;
    },
    getModal: function getModal(state) {
      return state.cancelModal;
    },
    getPreparedTickets: function getPreparedTickets(state) {
      return state.preparedTickets;
    },
    getTicketFormat: function getTicketFormat(state) {
      return state.ticketFormat;
    }
  },
  actions: {
    setHoldToken: function setHoldToken(payload) {
      this.holdToken = payload;
    },
    clearHoldToken: function clearHoldToken() {
      this.holdToken = null;
    },
    setSelectSeatsMode: function setSelectSeatsMode(payload) {
      this.selectSeatsMode = payload;
    },
    clearSelectSeatsMode: function clearSelectSeatsMode() {
      this.selectSeatsMode = null;
    },
    setEvent: function setEvent(payload) {
      this.event = payload;
    },
    setEmails: function setEmails(payload) {
      this.emails = payload;
    },
    setNote: function setNote(payload) {
      this.note = payload;
    },
    clearNote: function clearNote() {
      this.note = null;
    },
    clearEmails: function clearEmails() {
      this.emails = [];
      this.validSteps = [];
    },
    addStepValid: function addStepValid(payload) {
      if (this.validSteps.includes(payload)) {
        return;
      }
      this.validSteps.push(payload);
    },
    removeStepValid: function removeStepValid(payload) {
      var index = this.validSteps.indexOf(payload);
      if (index > -1) {
        this.validSteps.splice(index, 1);
      }
    },
    setTickets: function setTickets(payload) {
      // check if ticket is already in the list
      var index = this.tickets.findIndex(function (ticket) {
        var _ticket$timeslot, _payload$timeslot;
        return ticket.id === payload.id && (ticket === null || ticket === void 0 ? void 0 : (_ticket$timeslot = ticket.timeslot) === null || _ticket$timeslot === void 0 ? void 0 : _ticket$timeslot.id) === (payload === null || payload === void 0 ? void 0 : (_payload$timeslot = payload.timeslot) === null || _payload$timeslot === void 0 ? void 0 : _payload$timeslot.id);
      });
      if (index > -1) {
        this.tickets[index] = payload;
      } else {
        this.tickets.push(payload);
      }
    },
    clearTickets: function clearTickets() {
      this.tickets = [];
    },
    setPreparedTickets: function setPreparedTickets(payload) {
      this.preparedTickets = payload;
    },
    setModal: function setModal(payload) {
      this.cancelModal = payload;
    },
    setTicketFormat: function setTicketFormat(payload) {
      this.ticketFormat = payload;
    },
    clearState: function clearState() {
      this.validSteps = [];
      this.emails = [];
      this.tickets = [];
      this.preparedTickets = [];
      this.cancelModal = false;
      this.ticketFormat = null;
      this.note = null;
      this.selectSeatsMode = null;
      this.holdToken = null;
    }
  },
  persist: true
});

// VUE 2.7 WORKAROUND — see composables/usePinia.ts. Remove this wrapper at
// the Vue 3 flip and export useSendTicketsStoreDefinition directly as
// useSendTicketsStore instead.
export function useSendTicketsStore() {
  return useSendTicketsStoreDefinition(usePinia());
}